export const Const = {
  yn: [
    { value: '1', text: 'Yes' },
    { value: '0', text: 'No' }
  ],
  loanDirections: [
    { value: 'out', text: 'Out' },
    { value: 'in', text: 'In' }
  ]
};